import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'

interface DeleteDialogState {
  isOpen: boolean
  nodeId: string | null
  nodeLabel: string | null
  mode: 'confirm' | 'cannot-delete'
  childNodeIdList: string[]
}

export interface AgencyFlowDeleteDialogProps {
  state: DeleteDialogState
  onClose: () => void
  onConfirm: () => void
}

const getDialogTitle = (mode: DeleteDialogState['mode']): string =>
  mode === 'confirm' ? 'Delete Agent' : 'Cannot Delete Agent'

const getDialogDescription = (state: DeleteDialogState): string => {
  if (state.mode === 'confirm') {
    return `Are you sure you want to delete "${state.nodeLabel}"? This action cannot be undone.`
  }
  return `This agent has ${state.childNodeIdList.length} child agent(s) connected. Delete child agents first.`
}

export const AgencyFlowDeleteDialog = ({
  state,
  onClose,
  onConfirm,
}: AgencyFlowDeleteDialogProps): ReactNode => (
  <ConfirmDialog
    isOpen={state.isOpen}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    title={getDialogTitle(state.mode)}
    description={getDialogDescription(state)}
    confirmLabel={state.mode === 'confirm' ? 'Delete' : 'OK'}
    cancelLabel={state.mode === 'confirm' ? 'Cancel' : 'Close'}
    onConfirm={onConfirm}
    variant={state.mode === 'confirm' ? 'destructive' : 'default'}
  />
)

AgencyFlowDeleteDialog.displayName = 'AgencyFlowDeleteDialog'
